import React, { useState } from "react";
import SearchDetail from './SearchDetail';
import TableDetail from './TableDetail';
import styles from "../../Css/List.module.scss";

const PhysicalTakeDetail = ({ restaurant, physicTakeHeaderCode }) => {
    const [name,    setName]    = useState('');
    const [code,    setCode]    = useState('');
    const [area,    setArea]    = useState('');
    const [group,   setGroup]    = useState('');
    const [movements,  setMovements]  = useState(1);
    const [look,    setLook]    = useState(false);

    const searchParameter = (objectFilter) => {
        setName(objectFilter.nameArticle);
        setCode(objectFilter.codeArticle);
        setArea(objectFilter.areasArticle);
        setGroup(objectFilter.groupArticle);
        setMovements(objectFilter.movementsArticle);
        setLook(!look);
    }

    const searchAll = () => {
        setName('');
        setCode('');
        setArea('');
        setGroup('');
        setMovements(1);
        setLook(!look);
    }

    const fnFilterName = (e) => {
        if(e.currentTarget){
            setName(e.currentTarget.value);
        } else {
            setName(e);
        }
    }

    return (
        <div style={{ width: "100%" }}>
            <SearchDetail
                fnSearch={searchParameter}
                fnSearchAll={searchAll}
                fnFilterName={fnFilterName}
                physicTakeHeaderCode={physicTakeHeaderCode}
            />
            <div className={styles.center}>
                <TableDetail
                    name={name}
                    code={code}
                    look={look}
                    area={area}
                    group={group}
                    movements={movements}
                    restaurant={restaurant}
                    physicTakeHeaderCode={physicTakeHeaderCode}
                />
            </div>
        </div>
    );
}

export default PhysicalTakeDetail;